import { CreateWarehouseBody, UpdateWarehouseBody, Warehouse } from '@core/models/warehouse.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class WarehouseService {
    private readonly createWarehouseURL = `/warehouse/create_warehouse`;
    private readonly updateWarehouseURL = `/warehouse/update_warehouse`;
    private readonly getWarehousesURL = `/warehouse/get_warehouses`;
    private readonly getWarehouseByIdURL = `/warehouse/get_warehouse`;
    private readonly deleteWarehouseURL = `/warehouse/delete_warehouse`;

    // ---------------------------------------------------------------

    createWarehouse(body: CreateWarehouseBody) {
        return fetchWithRetry(API.post(this.createWarehouseURL, body));
    }

    updateWarehouse(body: UpdateWarehouseBody) {
        return fetchWithRetry(API.put(this.updateWarehouseURL, body));
    }

    getWarehouses() {
        return fetchWithRetry(API.get<Warehouse[]>(this.getWarehousesURL));
    }

    getWarehouseById(warehouseId: number) {
        return fetchWithRetry(API.get<Warehouse>(`${this.getWarehouseByIdURL}/warehouseId=${warehouseId}`));
    }

    deleteWarehouse(id: number) {
        return fetchWithRetry(API.delete(`${this.deleteWarehouseURL}/${id}`));
    }
}

export default new WarehouseService();

